import validateVar from "./validation/validateVariable";

function checkIfHasPreProvider (internal_customer_id) {
    return validateVar(internal_customer_id);
}

export default checkIfHasPreProvider;